import { Disclaimer } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";

import { useResultsContext } from "~/contexts/ResultsContext";

export const ResultsDisclaimer: React.FC = () => {
  const [t] = useTranslation("results");
  const { tasksStatus } = useResultsContext();

  const { show, handleClose } = Disclaimer.useShowState({
    initial: tasksStatus.completedFirstDiagnostic,
    localStorageKey: "showDisclaimerResults",
  });

  return (
    <Disclaimer.Card show={show}>
      <Disclaimer.Text>{t("disclaimer.text")}</Disclaimer.Text>
      <Disclaimer.Button onPress={handleClose}>
        {t("disclaimer.close")}
      </Disclaimer.Button>
    </Disclaimer.Card>
  );
};
